// Author thq
// Date 2022-04-04 18:10:58

import * as model from "@/model/em/archive/EmArchBdaRelSppBrsModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmArchBdaRelSppBrs(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
    })
    .buildStore()
